'use strict';

angular.module('app.error')
    .controller('ErrorController', ['$stateParams', function($stateParams) {
        var vm = this;

        vm.errString = $stateParams.type + '::' + $stateParams.code;

        switch ($stateParams.code) {
            case 'user-not-in-study':
            case 'permission-required':
            case 'not-found':
                vm.template = 'html/error/' + $stateParams.code + '.html';
                break;

            case 'generic':
            default:
                vm.template = null;
        }
    }]);
